import React from 'react';
import { withFormik } from 'formik';
import * as Yup from 'yup';
import FormControl from 'components/Core/FormControl';
import { Col, Row } from 'components/Core/Grid';
import Button from 'components/Core/Button';
import RadioGroup from 'components/Core/RadioGroup';
import useIndustries from 'hooks/useIndustries';
import { getFormValid } from 'utils/formUtils';
import IndustrySelect from '../IndustrySelect';
import IndustrySelectOther from '../IndustrySelectOther';
import TechCountSelect from '../TechCountSelect';
import OfficeCountSelect from '../OfficeCountSelect';
import { SignupContainer } from './styles';

const RadioField = ({ values, options, ...props }) => (
  <RadioGroup
    {...props}
    value={values[props.id]}
    options={options.map((x) => (x.label ? x : { value: x, label: x }))}
  />
);

const Signup4 = ({ onFinish, errorMessage, data = {}, ...otherProps }) => {
  const {
    values,
    handleChange,
    handleBlur,
    handleSubmit,
    setFieldValue,
    touched,
    errors,
    isValid,
    submitCount,
    onBack,
  } = otherProps;

  const { industryList, otherIndustryList } = useIndustries();

  const formValid = getFormValid({ errors, submitCount });

  return (
    <SignupContainer>
      <h4>Customize Your Toolbox</h4>
      <div>
        <RadioField
          id="companyRole"
          nameType="Whats your role at the company?"
          values={values}
          options={['Owner', 'Field Tech', 'Dispatcher', 'CSM']}
          handleFocus={(id, value) => setFieldValue(id, value)}
          formValid={formValid}
          formErrors={errors}
        />

        <IndustrySelect
          id="industry"
          placeholder="Select Industry"
          label="Whats your company's main industry?"
          values={values}
          handleChange={(id, value) => setFieldValue(id, value)}
          formValid={formValid}
          formErrors={errors}
          options={industryList}
          MenuProps={{ PopoverClasses: { paper: 'modal' } }}
        />

        {values.industry && values.industry === 'Other' && (
          <IndustrySelectOther
            id="industryOther"
            placeholder="Select Other Industry"
            values={values}
            handleChange={(id, value) => setFieldValue(id, value)}
            formValid={formValid}
            formErrors={errors}
            options={otherIndustryList}
            MenuProps={{ PopoverClasses: { paper: 'modal' } }}
          />
        )}
        {values.companyRole && values.companyRole !== 'Field Tech' && (
          <>
            <TechCountSelect
              id="techCount"
              placeholder="Select Technician Count"
              label="How many technicians work at your company?"
              values={values}
              handleChange={(id, value) => setFieldValue(id, value)}
              formValid={formValid}
              formErrors={errors}
              MenuProps={{ PopoverClasses: { paper: 'modal' } }}
            />

            <OfficeCountSelect
              id="officeCount"
              placeholder="Select Office Staff Count"
              label="How many full-time office employees (eg. manager, dispatchers, CSRs, etc) work
                at your company?"
              values={values}
              handleChange={(id, value) => setFieldValue(id, value)}
              formValid={formValid}
              formErrors={errors}
              MenuProps={{ PopoverClasses: { paper: 'modal' } }}
            />
          </>
        )}
        {errorMessage && (
          <FormControl>
            <p>
              <span className="input-failed-value">{errorMessage}</span>
            </p>
          </FormControl>
        )}
        <Row>
          <Col md={12}>
            <Button type="white" shadow={false} width="100%" onClick={() => onBack()} noSubmit>
              Back
            </Button>
          </Col>
          <Col md={12}>
            <Button
              type="secondary"
              width="100%"
              shadow={false}
              button
              disabled={!isValid && touched}
              onClick={handleSubmit}
            >
              Finish
            </Button>
          </Col>
        </Row>
      </div>
    </SignupContainer>
  );
};

const vSchema = Yup.object().shape({
  companyRole: Yup.string().required('Company Role is required').nullable(),
  industry: Yup.string().required('Industry is required').nullable(),
  industryOther: Yup.string().when('industry', {
    is: 'Other',
    then: Yup.string().required('Other Industry is required'),
  }),
  techCount: Yup.string().when('companyRole', {
    is: (value) => value !== 'Field Tech',
    then: Yup.string().required('Tech Count is required'),
  }),
  officeCount: Yup.string().when('companyRole', {
    is: (value) => value !== 'Field Tech',
    then: Yup.string().required('Office Count is required'),
  }),
});

export default withFormik({
  validationSchema: vSchema,
  mapPropsToValues: ({ data }) => data,
  handleSubmit: (values, { props, setErrors }) => {
    props.onFinish(values);
  },
})(Signup4);
